export default "__VITE_ASSET__DzZ1dpph__"